import {AfterViewInit, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {HttpService} from "./_service/http.service";
import {ActivatedRoute, Router} from "@angular/router";
import {OrganizationService} from "./_service/organization.service";
import {ViewSettingService} from "./main-page/view-setting-service/view-setting.service";
import {isNullOrUndefined} from "util";

declare const $: any;

@Component({
  selector: 'app-root',
  // styleUrls: ['./../css/main.css'],
  templateUrl: './app.component.html',
  // moduleId: module.id,
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  title = 'app';
  objLoaderStatus: boolean;

  constructor(private httpService: HttpService,
              private router: Router, private route: ActivatedRoute,
              private viewSettingService: ViewSettingService,
              private organizationService: OrganizationService) {
    this.objLoaderStatus = false;
  }


  ngOnInit() {

    $(function () {
      $('body').tooltip({
        selector: "[rel=tooltip]", // можете использовать любой селектор
        placement: "top"
      });
    });

  }

  // async checkAlias() {
  //    const alias = this.route.snapshot.params.alias;
  //    console.warn("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!In app component alias is : ", alias);
  //    if(isUndefined(alias)) return;
  //
  //    await this.organizationService.isAliasExist(alias).then(
  //      (isAliasExist) => {
  //          console.warn("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!In check alias in app result: ", isAliasExist);
  //        if (isAliasExist) {
  //          localStorage.setItem("organizationAlias", alias);
  //          this.router.navigate([alias + "/home"]);
  //        } else {
  //          this.router.navigate(["error"]);
  //        }
  //      });
  //    }

}




// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/app.component.ts